import { Flex, Box, InventoryOutlinedIcon, Text } from '@shared/components';

import { AddQBankStructureButton } from '../add-qbank-structure-button';

interface AddQBankStructureNoRowOverlayProps {
  onClick?: () => void;
}
export default function AddQBankStructureNoRowOverlay(props: AddQBankStructureNoRowOverlayProps) {
  const { onClick } = props;
  return (
    <Box sx={{ p: (theme) => theme.spacing(6) }}>
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(4),
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          py: (theme) => theme.spacing(11),
        })}
      >
        <InventoryOutlinedIcon
          sx={{ fontSize: '100px', color: (theme) => theme.palette.grey[400] }}
        />
        <Text variant='h3'>ยังไม่ได้เลือกคลังข้อสอบ</Text>
        <Text>โปรดเลือกคลังข้อสอบที่ต้องการใช้งาน พร้อมระบุจำนวนข้อสอบในแต่บท</Text>
        <Text>สามารถเพิ่มคลังข้อสอบได้มากกว่าหนึ่งคลัง</Text>
        <AddQBankStructureButton size='large' onClick={onClick} />
      </Flex>
    </Box>
  );
}
